var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type > 0)?_c('div',{staticClass:"tag-conten"},_vm._l((_vm.list),function(item){return _c('div',{key:item.txt,staticClass:"tag-box",style:({'color':item.textColor,'background':item.backColor})},[_vm._v(_vm._s(item.txt))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }